"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getViewport = exports["default"] = void 0;

var _forIn = _interopRequireDefault(require("lodash/forIn"));

var breakpoints = [];

function exists(alias) {
  var state = false;
  breakpoints.forEach(function (breakpoint) {
    if (breakpoint.name === alias) {
      state = true;
    }
  });
  return state;
}

var viewport = {
  onChange: function onChange() {},
  state: [],
  is: function is(alias) {
    if (!exists(alias)) {
      throw new Error("Unknown viewport alias: ".concat(alias));
    }

    return viewport.state.indexOf(alias) !== -1;
  }
};

function update() {
  viewport.state = [];
  breakpoints.forEach(function (breakpoint) {
    if (breakpoint.match.matches) {
      viewport.state.push(breakpoint.name);
    }
  });
  exportsViewport.state = viewport.state; // eslint-disable-line no-use-before-define
}

function change(mediaQueryList) {
  update();

  if (mediaQueryList.matches) {
    viewport.onChange(viewport.state);
  }
}

function removeListener() {
  breakpoints.forEach(function (breakpoint) {
    breakpoint.match.removeListener(change);
  });
  breakpoints = [];
}

function addListener(newBreakpoints) {
  (0, _forIn["default"])(newBreakpoints, function (key, name) {
    var breakpoint = {
      name: name,
      match: window.matchMedia(newBreakpoints[name])
    };
    breakpoints.push(breakpoint);
    breakpoint.match.addListener(change);
  });
}

function set(newBreakpoints) {
  if (!window.matchMedia) {
    throw new Error('Window.matchMedia is not available in this browser, please add a polyfill.');
  }

  removeListener();
  addListener(newBreakpoints);
  update();
}

var getViewport = function getViewport() {
  return {
    height: window.innerHeight || document.documentElement.offsetHeight,
    width: window.innerWidth || document.documentElement.offsetWidth
  };
};

exports.getViewport = getViewport;
var exportsViewport = {
  state: viewport.state,
  is: viewport.is,
  set: set,
  onChange: function onChange(callback) {
    viewport.onChange = callback;
  }
};
var _default = exportsViewport;
exports["default"] = _default;